import _util from '../../utils/';


const recruitmentSettingService = {
	selectRecruitmentSetting(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersRecruitAccountSetting/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	deleteRecruitmentSetting(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersRecruitAccountSetting/Delete',
			method: "delete",
			data: data,
			success: resolve,
			error: reject
		})
	},
	updateRecruitmentSetting(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersRecruitAccountSetting/Put',
			method: "put",
			data: data,
			success: resolve,
			error: reject
		})
	},
	createRecruitmentSetting(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersRecruitAccountSetting/Post',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
};


export default recruitmentSettingService;


// WEBPACK FOOTER //
// ./src/services/Recruitment/recruitment-setting-service.js